import React, { Component } from 'react'

import SalesWizard from "components/SalesWizard/SalesWizard";

export default class SaleView extends Component {
    render() {
        return (
            <div className="fade-show">
                <div className="row">
                    <div className="col-md-12">
                        <h1 className="header">Nueva Afiliación</h1>
                    </div>
                </div>

                <SalesWizard />
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/views/SaleView/SaleView.jsx